import React, {useState} from 'react';

import {gt} from 'app/utils/i18n';

import type {BasicTeamSerializedType} from 'sweet-types';

type TeamBadgeListProps = {
  text: string;
  allTeams: Array<BasicTeamSerializedType>;
  collapse?: boolean;
  urlExtractor?: (team: BasicTeamSerializedType) => string;
};

const MAX_TEAM_DISPLAY = 10;

export function TeamBadgeList({
  text,
  allTeams,
  urlExtractor,
  collapse = false,
}: TeamBadgeListProps) {
  if (allTeams.length === 0) {
    return null;
  }

  let teams = allTeams;
  let extraTeams: Array<BasicTeamSerializedType> = [];

  if (collapse) {
    teams = allTeams.slice(0, MAX_TEAM_DISPLAY);
    extraTeams = allTeams.slice(MAX_TEAM_DISPLAY);
  }

  const [isCollapsed, setIsCollapsed] = useState<boolean>(true);
  return (
    <div className="list-group my-3">
      <div className="small text-secondary mt-2">{text}</div>
      {teams.map((basicTeam) => (
        <TeamBadge
          key={basicTeam.id}
          basicTeam={basicTeam}
          url={
            urlExtractor != null ? urlExtractor(basicTeam) : basicTeam.html_url
          }
        />
      ))}
      {extraTeams.length > 0 && isCollapsed ? (
        <a
          href="#"
          className="list-group-item list-group-item-action text-primary"
          onClick={() => setIsCollapsed(false)}
        >
          {gt('And %s more...', extraTeams.length)}
        </a>
      ) : null}
      {!isCollapsed
        ? extraTeams.map((basicTeam) => (
            <TeamBadge
              key={basicTeam.id}
              basicTeam={basicTeam}
              url={
                urlExtractor != null
                  ? urlExtractor(basicTeam)
                  : basicTeam.html_url
              }
            />
          ))
        : null}
    </div>
  );
}

type TeamBadgeProps = {
  basicTeam: BasicTeamSerializedType;
  url: string;
};

function TeamBadge({basicTeam, url}: TeamBadgeProps) {
  return (
    <a href={url} className="list-group-item list-group-item-action">
      <span>
        <i className="fa fa-fw fa fa-users mr-1"></i>
        {basicTeam.name}
      </span>
    </a>
  );
}
